import { ActionBrick, registerBrick, Transaction, ErrorFlow } from 'olympe';

export default class RGProcessChangesForCloudObjects extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<!RGChange>} changes
     * @param {boolean} executeAsLarge
     * @param {function()} forwardEvent
     * @param {function(!ErrorFlow)} setErrorFlow
     */
    update(_$, [changes, executeAsLarge], [forwardEvent, setErrorFlow]) {
        const t = new Transaction();
        const errors = ['No changes applied because:'];
        changes.forEach(change => {
            if(change.metadata.newCell.validator?.(change.newValue) ?? true) {
                t.update(change.object, change.property, change.newValue);
            }
            else {
                errors.push(`This value is not valid: ${change.newValue}`);
            }
        });
        if(errors.length > 1) {
            setErrorFlow(ErrorFlow.create(errors.join('\n'), 1));
            return;
        }
        const promise = executeAsLarge ? t.executeAsLarge() : t.execute();
        promise.then(forwardEvent)
            .catch(error => setErrorFlow(ErrorFlow.create(error.message, 0)));
    }
}

registerBrick('01920a8134e1cf0fa551', RGProcessChangesForCloudObjects);
